import type {ReactElement} from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {useAppSelector} from '@/hooks';
import './page-slider.scss';
import {onPosterPause} from '@Components/poster-editor/library/poster-editor-library';
import {getPageStartAndEndTime, isPagePlaybackEnded, isPageVideo} from '@Components/poster-editor/poster-editor-reducer';

interface PageSliderProps {
  pageId: string;
}

export function PageSlider({...props}: PageSliderProps): ReactElement | null {
  const page = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap[props.pageId];
  });
  const currentTime = useAppSelector((state) => {
    return state.posterEditor.currentTime;
  });
  const pageTimes = useAppSelector((state) => getPageStartAndEndTime(state, props.pageId));
  const hasPageEnded = useAppSelector((state) => isPagePlaybackEnded(state, props.pageId));
  const isVideoPage = useAppSelector((state) => isPageVideo(state, props.pageId));
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });
  const setCurrentTime = (newValue: number | number[]): void => {
    void window.posterEditor?.whiteboard?.seek(newValue as number);
  };

  if (!page || !pageTimes || !isVideoPage) {
    return null;
  }

  const [pageStartTime, pageEndTime] = pageTimes;

  if (page.duration === 0) {
    return null;
  }

  const onSlide = (value: number): void => {
    onPosterPause();
    const actualTime = value + pageStartTime;
    setCurrentTime(actualTime);
  };

  const getVal = (): number => {
    if (hasPageEnded) {
      return page.duration;
    }

    return currentTime > pageEndTime ? 0 : currentTime - pageStartTime;
  };

  return <ControlledSlider className={`page-slider ${isTimelineModeActive ? '_hidden' : ''}`} value={getVal()} step={0.01} min={0} max={page.duration} onSlide={onSlide} />;
}
